"use client"

import { useState } from "react"
import { Edit2,  Info, X } from "lucide-react"
import { Button } from "./Button"
import { Card, CardContent } from "./Card"
import { RadioGroup, RadioGroupItem } from "./radio-group"
import { Label } from "./label"
import { Separator } from "./Separator"
import { Popover, PopoverContent, PopoverTrigger } from "./Popover"
import moment from "moment"
import "moment/locale/es"
import { selectPrice, total } from "../../utils/details"
import { differenceInDays } from "../../utils/diferentDays"
import Checkout from "../../pages/Checkout/Index"
import { DateRange } from "react-date-range";

interface PaymentViewProps {
    form: any
    setForm: any
    user: any
    data: any
    commission: number
}

export default function PaymentView({ form, setForm, user, data, commission }: PaymentViewProps) {
    const [paymentMethod, setPaymentMethod] = useState("full");
    const [isEditingDates, setIsEditingDates] = useState(false);
    const [isEditingGuests, setIsEditingGuests] = useState(false);
    const [dateRange, setDateRange] = useState<any>(null)

    // Calculamos los datos de la reserva basados en los props
    const basePrice = selectPrice(
        data.property.price,
        data.property?.prices ?? [],
        data.guests || form.guests
    )
    const nights = form.differenceDay || differenceInDays(form.start_date, form.end_date)
    const subtotal = basePrice * nights
    const totalAmount = total({
        ...data.property,
        price: subtotal,
    })
    const commissionAmount = totalAmount * (commission / 100)
    const partialPaymentAmount = commissionAmount
    const remainingAmount = totalAmount - partialPaymentAmount

    const handleSaveDateRange = () => {
        if (dateRange) {
            setForm({
                ...form,
                start_date: dateRange[0].startDate,
                end_date: dateRange[0].endDate,
                differenceDay: differenceInDays(dateRange[0].startDate, dateRange[0].endDate)
            })
            setIsEditingDates(false)
        }
    }

    const handleCancelDateEdit = () => {
        setDateRange([{
            startDate: new Date(form.start_date),
            endDate: new Date(form.end_date),
            key: 'selection',
            color: "#414141"
        }])
        setIsEditingDates(false)
    }

    
    return (
        <div className="container mx-auto px-4 py-8 max-w-6xl">
            <div className="mb-8">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Confirmá y pagá</h1>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* Columna izquierda - Detalles del viaje y pago */}
                <div className="lg:col-span-2 space-y-6">
                    {/* Tu viaje */}
                    <Card>
                        <CardContent className="p-6">
                            <h2 className="text-xl font-semibold mb-4">Tu viaje</h2>

                            {/* Fechas */}
                            <div className="flex items-center justify-between py-4 border-b">
                                <div>
                                    <h3 className="font-medium text-gray-900">Fechas</h3>
                                    <p className="text-gray-600">
                                        {moment(form.start_date).locale("es").format("D [de] MMMM")} al {moment(form.end_date).locale("es").format("D [de] MMMM [de] YYYY")}
                                    </p>
                                </div>
                                <Popover open={isEditingDates} onOpenChange={() => {
                                    setIsEditingDates(true)
                                    setDateRange([{
                                        startDate: new Date(form.start_date),
                                        endDate: new Date(form.end_date),
                                        key: 'selection',
                                        color: "#414141"
                                    }])
                                }}
                                >
                                    <PopoverTrigger asChild className={form.excursion ? "hidden" : ""}>
                                        <Button variant="outline" size="sm">
                                            <Edit2 className="w-4 h-4 mr-2" />
                                            Editar
                                        </Button>
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto p-0" align="end">
                                        <div className="p-4">
                                            <div className="flex items-center justify-between mb-4">
                                                <h4 className="font-medium">Seleccionar fechas</h4>
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    onClick={handleCancelDateEdit}
                                                >
                                                    <X className="w-4 h-4" />
                                                </Button>
                                            </div>
                                            <div className="py-3 flex lg:hidden">
                                                {dateRange ? (
                                                    <DateRange
                                                        showDateDisplay={false}
                                                        // showSelectionPreview={false}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        onChange={(item: any) => {
                                                            setDateRange([item.selection]);
                                                        }}
                                                        ranges={dateRange}
                                                        months={1}
                                                        direction="horizontal"
                                                        rangeColors={["#414141"]}
                                                    //disabledDates={disabledDays}
                                                    // locale={locale}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <div className="py-3 lg:flex hidden">
                                                {dateRange ? (
                                                    <DateRange
                                                        showDateDisplay={false}
                                                        // showSelectionPreview={false}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        onChange={(item: any) => {
                                                            setDateRange([item.selection]);
                                                        }}
                                                        ranges={dateRange}
                                                        months={2}
                                                        direction="horizontal"
                                                        rangeColors={["#414141"]}
                                                    //disabledDates={EachDayOfInterval(property.reservations)}
                                                    //disabledDates={disabledDays}
                                                    // locale={locale}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <div className="flex justify-end gap-2 mt-4">
                                                <Button
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={handleCancelDateEdit}
                                                >
                                                    Cancelar
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    onClick={handleSaveDateRange}
                                                    disabled={!dateRange}
                                                >
                                                    Guardar
                                                </Button>
                                            </div>
                                        </div>
                                    </PopoverContent>
                                </Popover>
                            </div>

                            {/* Viajeros */}
                            <div className="flex items-center justify-between py-4">
                                <div>
                                    <h3 className="font-medium text-gray-900">Viajeros</h3>
                                    <p className="text-gray-600">{data.guests || form.guests || 1} viajeros</p>
                                </div>

                                <Popover open={isEditingGuests} onOpenChange={() => {
                                    setIsEditingGuests(true)
                                }}
                                >
                                    <PopoverTrigger asChild className={form.excursion ? "hidden" : ""}>
                                        <Button variant="outline" size="sm">
                                            <Edit2 className="w-4 h-4 mr-2" />
                                            Editar
                                        </Button>
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto p-0" align="end">
                                        <div className="p-4">
                                            <div className="flex items-center justify-between mb-4">
                                                <h4 className="font-medium">Cantidad de viajeros</h4>
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    onClick={() => {
                                                        setIsEditingGuests(false)
                                                    }}
                                                >
                                                    <X className="w-4 h-4" />
                                                </Button>
                                            </div>
                                            <div className="py-3 flex ">


                                                <div className="flex md:justify-end">
                                                    <label
                                                        className={`cursor-pointer border border-grey-10 justify-center items-center flex w-[50px] h-[50px]`}
                                                        style={{ borderRadius: "50%", fontSize: "30px" }}
                                                    >
                                                        -
                                                        <button
                                                            className="hidden"
                                                            onClick={() => {
                                                                if (form.guests > 0) {
                                                                    setForm({
                                                                        ...form,
                                                                        guests: form.guests - 1,
                                                                    });
                                                                }
                                                            }}
                                                        ></button>
                                                    </label>
                                                    <span className="font-bold block mx-4 flex text-center text-black text-xl justify-center items-center h-[50px] w-[100px]">
                                                        {form?.guests}
                                                    </span>
                                                    <label
                                                        className={`cursor-pointer border border-grey-10 justify-center items-center  flex w-[50px] h-[50px]`}
                                                        style={{ borderRadius: "50%", fontSize: "30px" }}
                                                    >
                                                        +
                                                        <button
                                                            className="hidden"
                                                            onClick={() => {
                                                                if (form?.guests < data.property.travellers) {
                                                                    setForm({
                                                                        ...form,
                                                                        guests: form.guests + 1,
                                                                    });
                                                                }
                                                            }}
                                                        ></button>
                                                    </label>
                                                </div>

                                            </div>
                                            <div className="flex justify-end gap-2 mt-4">
                                                <Button
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={() => {
                                                        setIsEditingGuests(false)
                                                    }}
                                                >
                                                    Cancelar
                                                </Button>
                                            </div>
                                        </div>
                                    </PopoverContent>
                                </Popover>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Elegí cómo pagar */}
                    <Card>
                        <CardContent className="p-6">
                            <h2 className="text-xl font-semibold mb-4">Elegí cómo pagar</h2>

                            <RadioGroup value={paymentMethod} onValueChange={setPaymentMethod} className="space-y-4">
                                {/* Pago único */}
                                <div className="flex items-start space-x-3 p-4 border rounded-lg">
                                    <RadioGroupItem value="full" id="full" className="mt-1" />
                                    <div className="flex-1">
                                        <Label htmlFor="full" className="font-medium cursor-pointer">
                                            Pago único
                                        </Label>
                                        <p className="text-sm text-gray-600 mt-1">
                                             {`Paga una de ${commission}% para reservar ($${(
                                                total({
                                                    ...form.property,
                                                    price:
                                                        selectPrice(
                                                            form.property.price,
                                                            form.property?.prices ?? [],
                                                            form.guests
                                                        ) * form.differenceDay,
                                                }) *
                                                (commission / 100)
                                            ).toLocaleString("de-DE", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}`})
                                        </p>
                                    </div>
                                </div>

                                {/* Pago parcial */}
                                <div className="flex items-start space-x-3 p-4 border rounded-lg hidden">
                                    <RadioGroupItem value="partial" id="partial" className="mt-1" />
                                    <div className="flex-1">
                                        <Label htmlFor="partial" className="font-medium cursor-pointer flex items-center gap-2">
                                            Paga una parte ahora y otra más adelante
                                            <Info className="w-4 h-4 text-gray-400" />
                                        </Label>
                                        <p className="text-sm text-gray-600 mt-1">
                                            Paga ${partialPaymentAmount.toLocaleString("de-DE", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })} hoy y $
                                            {remainingAmount.toLocaleString("de-DE", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })} el {moment(form.end_date).locale("es").format("D [de] MMMM [de] YYYY")}.
                                        </p>
                                        <p className="text-xs text-gray-500 mt-1">Sin cargos adicionales</p>
                                    </div>
                                </div>
                            </RadioGroup>
                        </CardContent>
                    </Card>

                    {/* Métodos de pago */}
                    <Card>
                        <CardContent className="p-6">
                            <h2 className="text-xl font-semibold mb-4">Métodos de pago</h2>

                            <div className="space-y-3">
                                {/* MercadoPago */}
                                <Checkout
                                    reserva={{
                                        ...form,
                                        title: data.property.title,
                                        property: data.property,
                                    }}
                                    user={user}
                                />
                            </div>
                        </CardContent>
                    </Card>
                </div>

                {/* Columna derecha - Resumen de la reserva */}
                <div className="lg:col-span-1">
                    <Card className="sticky top-24">
                        <CardContent className="p-6">
                            {/* Información del alojamiento */}
                            <div className="flex gap-4 mb-6">
                                <div className="relative w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                                    <img
                                        src={form.property.images[0].url || "/placeholder.svg"}
                                        alt={form.property.title}
                                        className="object-cover"
                                    />
                                </div>
                                <div className="flex-1">
                                    <h3 className="font-semibold text-gray-900 mb-1">{form.property.title}</h3>
                                    <p className="text-sm text-gray-600">{form.property.description}</p>
                                </div>
                            </div>

                            <Separator className="mb-6" />

                            {/* Detalles del precio */}
                            <div>
                                <h3 className="font-semibold text-gray-900 mb-4">Detalles del precio</h3>

                                <div className="space-y-3 text-sm">
                                    <div className="flex justify-between">
                                        <span className="text-gray-700">
                                            ${basePrice.toLocaleString("de-DE", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })} {data.property.currency} por {nights} noches
                                        </span>
                                        <span className="text-gray-900">
                                            ${subtotal.toLocaleString("de-DE", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })} {data.property.currency}
                                        </span>
                                    </div>

                                    {data.property.fees.map((fee: any, index: number) => {
                                        if (fee.price > 0) {
                                            return (
                                                <div key={index} className="flex justify-between">
                                                    <span className="text-gray-700">{fee.name}</span>
                                                    <span className="text-gray-900">
                                                        ${fee.price.toLocaleString("de-DE", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })} {data.property.currency}
                                                    </span>
                                                </div>
                                            )
                                        }
                                        return null
                                    })}

                                    <Separator className="my-3" />

                                    <div className="flex justify-between font-semibold text-base">
                                        <span>Total ({data.property.currency})</span>
                                        <span>${totalAmount.toLocaleString("de-DE", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Información adicional */}
                            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
                                <div className="flex items-start gap-2">
                                    <Info className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
                                    <div className="text-sm text-blue-800">
                                        <p className="font-medium mb-1">Precio garantizado</p>
                                        <p>Este precio está garantizado y no cambiará hasta que completes tu reserva.</p>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    )
}
